import QuickAccess from "./components/QuickAccess.jsx";

const { createRoot, createElement } = wp.element;

/**
 * La liste des besoins vient du back-office, sérialisée dans l'attribut. Un JSON
 * malformé ne doit pas empêcher le formulaire de se monter : on retombe sur une
 * liste vide, et le champ des besoins ne s'affiche alors pas.
 */
function parseNeeds(raw) {
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".manitoba-leads-quickaccess").forEach((el) => {
    const root = createRoot(el);
    root.render(
      createElement(QuickAccess, {
        title: el.getAttribute("data-title"),
        acceptTerms: el.getAttribute("data-accept-terms"),
        needs: parseNeeds(el.getAttribute("data-needs")),
      })
    );
  });
});
